var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading && (_vm.isFeatureFlagEnabled || _vm.allowDisabled))?_c('div',{staticClass:"feature-flag",class:{
        [_vm.display]: _vm.display,
        enabled: _vm.isFeatureFlagEnabled,
        disabled: !_vm.isFeatureFlagEnabled,
    },style:({ flexGrow: _vm.grow, marginRight: _vm.margin, maxWidth: _vm.width })},[(_vm.isFeatureFlagEnabled)?_vm._t("default"):_vm._e(),(_vm.isFeatureFlagEnabled)?_vm._t("enabled"):_vm._e(),(!_vm.isFeatureFlagEnabled)?_vm._t("disabled"):_vm._e()],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }